<div *ngIf="claim$ | async as claim" class="flex flex-col gap-4">
  <vs-card *ngIf="claim.warranty?.asset as asset">
    <vs-card-header
      [config]="{ title: asset.name, subtitle: 'Details for the asset linked to this claim.' }"
    ></vs-card-header>

    <div class="mx-6 my-4">
      <vs-property-set-values
        [propertySetId]="asset.propertySetId"
        [propertyValues]="(claim.propertySetSubmission ?? claim.warranty?.propertySetSubmission)?.value || {}"
        [dimensionValues]="(claim.propertySetSubmission ?? claim.warranty?.propertySetSubmission)?.dimensionValues || {}"
        [showHidden]="true"
      ></vs-property-set-values>
    </div>
  </vs-card>
</div>
